import React from "react";
import { SectionTitle } from "./section-title";
import { useId } from "../../../hooks/use-id";

export const FAQSection = () => {
	const titleRegionId = useId('preguntas');
	const faq1 = useId('faq1');
	const faq2 = useId('faq2');
	const faq3 = useId('faq3');
	const faq4 = useId('faq4');
	const faq5 = useId('faq5');
	const faq6 = useId('faq6');
	const faq7 = useId('faq7');
	const faq8 = useId('faq8');
	const faq9 = useId('faq9');

	return (
		<section aria-labelledby={titleRegionId} className="p-3 faq">
			<SectionTitle title="Preguntas frecuentes" labelId= {titleRegionId}/>
			<div className="p-3  justify-content-center align-items-center">
				<section aria-labelledby={faq1} className="my-3">
					<h3 id={faq1}>1. ¿Cómo ingreso a MakeMake? </h3>
					<p>
						Cada biblioteca pública participante recibió dos (2) credenciales de ingreso. Una es para uso único del personal de bibliotecas (bibliotecarios, promotores de lectura y personal asociado a la biblioteca), y la otra es la que se comparte con los usuarios (profesores, estudiantes, padres y madres de familia, etc.).
					</p>
					<p>
						Si aún tienes dudas sobre el acceso de tu biblioteca, por favor escribe a <a href="mailto:contacto@makemake.com.co" className="focusable-red">contacto@makemake.com.co </a>, aclarando tu nombre, el nombre de la biblioteca a la que perteneces y el municipio.
					</p>
				</section>

				<section aria-labelledby={faq2} className="my-3">
					<h3 id={faq2}>
						2. ¿Puedo compartir la clave de acceso de los usuarios? ¿Cómo puedo hacerlo?
					</h3>
					<p>
						Sí, puedes compartir la clave de acceso de los usuarios. Puedes hacerlo a través de la cartelera de la biblioteca, en los chats de WhatsApp con los usuarios o directamente a quienes lo soliciten.
					</p>
					<p>
						Sin embargo, las claves no deben compartirse en redes sociales ni en páginas web, ya que esta información es exclusiva para los usuarios de la biblioteca. Esto nos permite medir mejor el impacto directo que tienen las bibliotecas en sus comunidades al promover este servicio de lectura digital.
					</p>
				</section>

				<section aria-labelledby={faq3} className="my-3">
					<h3 id={faq3}>3. ¿Cómo sé a qué grupo pertenezco?</h3>
					<p>
						En la sección <strong>"Bibliotecas participantes"</strong> de este micrositio (ver la sección de arriba), encontrarás el nombre de las bibliotecas del piloto organizadas por grupo.
					</p>
				</section>

				<section aria-labelledby={faq4} className="my-3">
					<h3 id={faq4}>
						4. Aún no soy parte del grupo de WhatsApp, ¿qué debo hacer?
					</h3>
					<p>
						Si aún no estás en ningún grupo de WhatsApp, puedes escribirnos a <a href="mailto:contacto@makemake.com.co" className="focusable-red"> contacto@makemake.com.co </a> con la siguiente información: nombre completo, nombre de la biblioteca a la que perteneces, municipio y número de celular.
					</p>
					<p>
						El grupo de WhatsApp es el canal principal por donde enviaremos las comunicaciones del piloto. También enviaremos comunicaciones al correo electrónico registrado.
					</p>
				</section>

				<section aria-labelledby={faq5} className="my-3">
					<h3 id={faq5}>5. ¿Es necesario descargar la app para usar MakeMake?</h3>
					<p>
						No, no es necesario descargar la app para utilizar la Biblioteca Digital MakeMake. Puedes usar MakeMake directamente en el navegador de tu teléfono, tableta o computador. Te recomendamos que uses el navegador
						<a
							href="https://www.google.com/chrome"
							target="_blank"
							rel="noreferrer noopener"
							className="focusable-red"
						>
							{" "}
							Google Chrome
						</a>
						.
					</p>
				</section>

				<section aria-labelledby={faq6} className="my-3">
					<h3 id={faq6}>6. ¿Cómo descargo las apps de MakeMake y qué ventajas tiene hacerlo?</h3>
					<p>
						MakeMake tiene apps disponibles para teléfonos y tabletas Android y Apple, y también para computadores. En este sitio puedes encontrar las instrucciones para descargar las apps:{" "}
						<a href="https://makemake.app" target="_blank" rel="noreferrer noopener" className="focusable-red">
							https://makemake.app
						</a>
					</p>
					<p>
						La app de MakeMake te ayuda a tener acceso directo y recordar tus datos, lo que facilita el ingreso y a leer más rápidamente.
					</p>
				</section>

				<section aria-labelledby={faq7} className="my-3">
					<h3 id={faq7}>7. ¿Cómo leer libros sin internet?</h3>
					<ol className="ml-5">
						<li>
							Inicia sesión con el usuario de tu biblioteca.
						</li>
						<li>
							Selecciona el libro que quieres leer sin internet y accede a la ficha del libro haciendo clic en su portada.
						</li>
						<li>
							Busca el botón "Descargar" en la parte inferior de la imagen de la portada.
						</li>
						<li>
							Espera a que finalice el proceso de descarga.
						</li>
						<li>Una vez descargado, el botón cambiará a "Descargado".</li>
						<li>
							Puedes consultar el libro descargado en la sección "Descargas" del botón "Mi Cuenta".
						</li>
						<li>
							Si quieres más información sobre la descarga, consulta estos videos:
						</li>
						<ul>
							<li>
								<a
									href="https://vimeo.com/1023316893/5b97f98077"
									target="_blank"
									rel="noopener noreferrer"
									className="focusable-red"
								>
									Lectura sin internet de libros en tu computador
								</a>
							</li>
							<li>
								<a
									href="https://vimeo.com/995529495/7a1bf61a8b"
									target="_blank"
									rel="noopener noreferrer"
									className="focusable-red"
								>
									Lectura sin internet de libros en tu celular o tableta
								</a>
							</li>
						</ul>
					</ol>
					<p>
						<strong>Nota importante:</strong> Podrás tener un máximo de cuatro libros, los cuales estarán disponibles en tu dispositivo por 15 días. Puedes borrar los libros y seleccionar otros si así lo deseas.
					</p>
				</section>

				<section aria-labelledby={faq8} className="my-3">
					<h3 id={faq8}>8. ¿Cómo comunico a mi comunidad sobre este servicio?</h3>
					<p>
						En este micrositio encontrarás materiales para contarle a tu comunidad que existe MakeMake y que pueden hacer uso de la plataforma. Si quieres más piezas gráficas para comunicar MakeMake, puedes usar el
						<a
							href="https://makemake.com.co/centro-de-recursos"
							target="_blank"
							rel="noreferrer noopener"
							className="focusable-red"
						>
							{" "}
							Centro de Recursos
						</a>
						.
					</p>
					<p>
						<strong>Nota importante:</strong> Para descargar los materiales del Centro
						de Recursos debes previamente iniciar sesión en MakeMake con tu usuario y
						contraseña.
					</p>
				</section>

				<section aria-labelledby={faq9} className="my-3">
					<h3 id={faq9}>9. ¿Puedo compartir el Centro de recursos con mis usuarios?</h3>
					<p>
						Sí, puedes compartir el Centro de recursos con los usuarios para comunicarles sobre el nuevo servicio de lectura digital en MakeMake.
					</p>
				</section>
			</div>
		</section>
	);
};
